import Modal from '../components/modal';
import { getVideoEmbedURL } from './video-url';
import SiteEvents, { SiteEventNames } from './site-events';
import Marketo from '../integrations/marketo';
import { wpAPIget } from './wp-rest-api';

export function showVideoModal(videoUrl) {
	if (!videoUrl) {
		return;
	}

	const embedUrl = getVideoEmbedURL(videoUrl);

	Modal.show('', {
		modalClass: 'modal modal-video'
	});

	const isDirectURL = embedUrl.toLowerCase().indexOf('.mp4') !== -1;

	const templateMarkup = `
		<div class="modal__video-container">
			${
				isDirectURL
					? `
				<video class="modal__video-embed" src="${embedUrl}" controls autoplay></video>
			`
					: `
				<iframe class="modal__video-embed"
					src="${embedUrl}"
					width="640"
					height="360"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen>
				</iframe>
			`
			}
		</div>
	`;

	// set the content to begin the iframe load but do not remove the loading animation
	Modal.setContent(templateMarkup, false);

	const iframeEl = document.querySelector('.modal__video-embed');

	// wait for the 'load' event to fire before removing the loading animation
	iframeEl.addEventListener(isDirectURL ? 'loadeddata' : 'load', () => {
		Modal.setLoading(false);
	});
}

export function showTeamModal(params) {
	const markup = `
		<div class="modal__team-container">
			<img class="modal__team-image" src="${params.ibSources}" alt="${params.name}">
			<h2 class="modal__team-name">${params.name}</h2>
			<h4 class="modal__team-role">${params.role}</h4>
			<div class="modal__team-bio">${params.bio}</div>
		</div>
	`;

	Modal.show(markup, {
		modalClass: 'modal modal-team',
		callbacks: {
			onShow: () => {
				SiteEvents.publish(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE);
			}
		}
	});
}

export function showDemoModal(params) {
	Modal.show('', {
		modalClass: 'modal modal-demo'
	});

	const marketoFormId = params.marketoFormId ?? 0;

	const demoModalMarkup = `
		<div class="modal__demo-container">
			<div class="modal__demo-col modal__demo-col--content">
				${params.content ?? ''}
			</div>
			<div class="modal__demo-col modal__demo-col--form">
				${params.marketoFormMarkup ?? ''}
			</div>
		</div>
	`;

	// set the content to begin the iframe load but do not remove the loading animation
	Modal.setContent(demoModalMarkup, false);

	Marketo.emitter.on('form-loaded', ({ formId }) => {
		if (marketoFormId === formId) {
			Modal.setLoading(false);
		}
	});

	Marketo.loadForms();
}

export function getDemoModalParams() {
	return window?.apiSettings?.demoModal ?? {};
}

export function getGridModalParams() {
	return window?.apiSettings?.gridModal ?? {};
}

async function getFormModalParams(formId) {
	const params = {
		content: '',
		marketoFormId: 0,
		marketoFormMarkup: ''
	};

	try {
		const res = await wpAPIget(`wp/v2/modal_form/${formId}`);

		params.content = res?.body?.content?.rendered ?? '';
		params.marketoFormId = res?.body?.marketo_form_id ?? 0;
		params.marketoFormMarkup = res?.body?.marketo_form_markup ?? '';
	} catch (e) {
		params.content = e?.body?.message ?? 'An error occurred while loading the requested form.';
	}

	return params;
}

export async function showFormModal(modalFormId) {
	Modal.show('', {
		modalClass: 'modal modal-demo'
	});

	const params = await getFormModalParams(modalFormId);

	if (params.marketoFormMarkup) {
		const marketoFormId = params.marketoFormId ?? 0;

		const demoModalMarkup = `
			<div class="modal__demo-container">
				<div class="modal__demo-col modal__demo-col--content">
					${params.content ?? ''}
				</div>
				<div class="modal__demo-col modal__demo-col--form">
					${params.marketoFormMarkup ?? ''}
				</div>
			</div>
		`;

		// set the content to begin the iframe load but do not remove the loading animation
		Modal.setContent(demoModalMarkup, false);

		Marketo.emitter.on('form-loaded', ({ formId }) => {
			if (marketoFormId === formId) {
				Modal.setLoading(false);
			}
		});

		Marketo.loadForms();
	} else {
		Modal.setContent(`<p>${params.content}</p>`);
	}
}

export async function showContentModal(modalId) {
	Modal.show('', {
		modalClass: 'modal modal-demo'
	});

	let content = '';

	try {
		const res = await wpAPIget(`wp/v2/modal_content/${modalId}`);

		content = res?.body?.content?.rendered ?? '';
	} catch (e) {
		content = e?.body?.message ?? 'An error occurred while loading the requested form.';
	}

	Modal.setContent(content);

	SiteEvents.publish(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE);
}

export async function showGridModal(params) {
	Modal.show('', {
		modalClass: 'modal modal-grid'
	});

	const gridFormId = params.marketoFormId ?? 0;

	const gridModalMarkup = `
		<div class="modal__grid-container">
			<div class="modal__grid-col modal__grid-col--content">
				${params.content ?? ''}
			</div>
			<div class="modal__grid-col modal__grid-col--form">
				${params.marketoFormMarkup ?? ''}
			</div>
		</div>
	`;

	// set the content to begin the iframe load but do not remove the loading animation
	Modal.setContent(gridModalMarkup, false);

	Marketo.emitter.on('form-loaded', ({ formId }) => {
		if (gridFormId === formId) {
			Modal.setLoading(false);
		}
	});

	Marketo.loadForms();
}


